"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5644],{

/***/ 8797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yu": function() { return /* binding */ getMonthEvent; },
/* harmony export */   "EY": function() { return /* binding */ getEvent; },
/* harmony export */   "Xy": function() { return /* binding */ getEventList; },
/* harmony export */   "Ty": function() { return /* binding */ getEventBanner; }
/* harmony export */ });
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66);

/* =============================== GET ================================ */ /**
 * 현재 진행 중인 초저가 이벤트 상세 정보
 * @version 3
 */ var getMonthEvent = function() {
    return api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/enfit1/api/v3/cms/deal/1");
};
/**
 * 이벤트 상세 정보
 * @version 3
 * @param {object} props
 * @param {number} props.dealId 이벤트 ID
 */ var getEvent = function(param) {
    var _dealId = param.dealId, dealId = _dealId === void 0 ? 0 : _dealId;
    return api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/enfit1/api/v3/cms/deal/".concat(dealId));
};
/**
 * 현재 진행중인 이벤트 리스트 반환
 * @version 1
 */ var getEventList = function() {
    return api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/enfit2/api/v1/events");
};
/**
 * 이벤트 배너 리스트 반환
 * @version 3
 */ var getEventBanner = function() {
    return api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/enfit1/api/v3/class_overview", {
        headers: {
            Authorization: "Bearer ".concat("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vd3d3LmNsYXNzdS5jby5rci9tb2Rvby9zdG9yZUxvZ2luQVBJIiwiaWF0IjoxNzEyMTIyODAzLCJleHAiOjE3MTMzMzI0MDMsIm5iZiI6MTcxMjEyMjgwMywianRpIjoiM0IwbElaMnRBckNhbWRrQiIsInN1YiI6MTg0NzkwMSwicHJ2IjoiOTYyYTE0ZDQ4YzQyOWUzYTZhYWIzNjEwYzAzNTJiZmJiNDVlZmM1OCJ9.Th2dkBQJrfPwnoYRvoqRY0d-o9iD8T-tIBHwHGIF6fA")
        }
    });
}; /* =============================== POST =============================== */  /* =============================== PUT ================================ */  /* ============================== DELETE ============================== */ 


/***/ }),

/***/ 9772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_SideBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/cds/buttons/Text.tsx
var Text = __webpack_require__(8163);
// EXTERNAL MODULE: ./src/cds/icons/index.tsx
var icons = __webpack_require__(6643);
// EXTERNAL MODULE: ./src/hooks/common/useStore.ts
var useStore = __webpack_require__(8004);
// EXTERNAL MODULE: ./src/slices/category.thunk.js
var category_thunk = __webpack_require__(8651);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/molecules/common/SideNavigation.js



// components


// hooks


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 96px;\n  left: 232px;\n  width: 204px;\n  height: fit-content;\n  padding: 12px 0px;\n  border-radius: 4px;\n  background-color: ",
        ";\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  z-index: ",
        ";\n\n  & li {\n    position: relative;\n    padding: 0 4px;\n  }\n\n  & li > nav {\n    display: none;\n  }\n\n  & li:hover {\n    & nav {\n      display: flex;\n      position: absolute;\n      top: -12px;\n      left: 204px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 10px 0 20px;\n  transition: 0.1s ease;\n  font-size: 14px;\n  justify-content: space-between;\n  background-color: ",
        ";\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    & > svg {\n      fill: ",
        ";\n    }\n\n    &::before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
/**
 * 사이드 네비게이션
 * @param {object} props
 * @param {import('types/slices/category').Category[]} props.categoryList
 */ var NavItem = function(param) {
    var headCategory = param.headCategory, categoryList = param.categoryList, hasSubNav = param.hasSubNav;
    var dispatch = (0,useStore/* useDispatch */.I)();
    var subCategory = (0,useStore/* useSelector */.v)(function(state) {
        return state.category.subCategoryList;
    });
    var onMouseOver = function(category) {
        if (!hasSubNav) {
            return;
        }
        var hasOwnSubCategory = Object.prototype.hasOwnProperty.call(subCategory, category);
        if (hasOwnSubCategory) {
            return;
        }
        // 선택한 카테고리의 하위 카테고리를 fetching한다.
        dispatch((0,category_thunk/* getSubCategoryList */.Yj)({
            category: category
        }));
    };
    var List = categoryList.map(function(v, i) {
        var url = hasSubNav ? "/category?categoryId=".concat(v) : "/category?categoryId=".concat(headCategory, "&subCategoryId=").concat(v);
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            className: v,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                        as: "a",
                        size: "ExtraSmall",
                        color: styles/* palette.font.primary */.DG.font.primary,
                        onMouseOver: function() {
                            onMouseOver(v);
                        },
                        children: [
                            v,
                            hasSubNav && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                name: "ic_arrow_right_s",
                                width: 16,
                                height: 16,
                                fill: styles/* palette.grey50 */.DG.grey50
                            })
                        ]
                    })
                }),
                hasSubNav && subCategory[v] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Template, {
                    headCategory: headCategory[i],
                    categoryList: subCategory[v] ? subCategory[v].interests : [],
                    hasSubNav: false
                })
            ]
        }, v));
    });
    return List;
};
var Template = function(param) {
    var headCategory = param.headCategory, categoryList = param.categoryList, hasSubNav = param.hasSubNav;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Layout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                headCategory: headCategory,
                categoryList: categoryList,
                hasSubNav: hasSubNav
            })
        })
    });
};
var SideNavigation = function(param) {
    var categoryList = param.categoryList;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Template, {
        headCategory: categoryList,
        categoryList: categoryList,
        hasSubNav: true
    });
};
var Layout = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-d409f39d-0"
})(_templateObject(), styles/* palette.system.BNB */.DG.system.BNB, styles/* zIndex.header */.W5.header);
var Button = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-d409f39d-1"
})(_templateObject1(), styles/* palette.system.BNB */.DG.system.BNB, styles/* palette.BTN.BG */.DG.BTN.BG, styles/* palette.Primary.Active_Down_Tone */.DG.Primary.Active_Down_Tone, styles/* palette.red040 */.DG.red040, styles/* palette.Primary.Active_Down_Tone */.DG.Primary.Active_Down_Tone);
/* harmony default export */ var common_SideNavigation = (SideNavigation);

// EXTERNAL MODULE: ./src/cds/layout/VerticalScroll.tsx
var VerticalScroll = __webpack_require__(498);
// EXTERNAL MODULE: ./src/cds/buttons/Fill.tsx
var Fill = __webpack_require__(5549);
// EXTERNAL MODULE: ./src/slices/event.thunk.js
var event_thunk = __webpack_require__(7026);
// EXTERNAL MODULE: ./src/lib/utils/helper.js
var helper = __webpack_require__(4058);
// EXTERNAL MODULE: ./src/lib/utils/deviceChecker.js
var deviceChecker = __webpack_require__(7496);
// EXTERNAL MODULE: ./src/cds/typography.ts
var typography = __webpack_require__(506);
// EXTERNAL MODULE: ./src/slices/dataMining.ts
var dataMining = __webpack_require__(7990);
// EXTERNAL MODULE: ./src/slices/user.thunk.js + 1 modules
var user_thunk = __webpack_require__(9001);
// EXTERNAL MODULE: ./src/lib/utils/companyConvert.js
var companyConvert = __webpack_require__(5836);
// EXTERNAL MODULE: ./src/api/index.js + 1 modules
var api = __webpack_require__(66);
;// CONCATENATED MODULE: ./src/components/organisms/common/SideBar.js





// components





// slices


// hooks

// utils


// styles






function SideBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SideBar_templateObject() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  display: none;\n  position: fixed;\n  top: 84px;\n  left: 0;\n  width: 240px;\n  max-width: 100%;\n  z-index: ",
        ";\n  box-sizing: content-box;\n\n  ",
        " {\n    display: flex;\n    flex-direction: column;\n  }\n  * {\n    color: ",
        ";\n  }\n"
    ]);
    SideBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SideBar_templateObject1() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  overflow-y: auto;\n  height: calc(100vh - 84px);\n  background-color: ",
        ";\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0;\n    background-color: transparent;\n  }\n"
    ]);
    SideBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  position: fixed;\n  width: 240px;\n  left: 0;\n  padding: 12px 8px 8px;\n  z-index: 1;\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 4px;\n    left: 0;\n    bottom: -4px;\n    right: 0;\n    /* background: linear-gradient(to bottom, white, rgba(255, 255, 255, 0)); */\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 44px;\n  padding: 8px 24px;\n  z-index: 1;\n\n  & > div {\n    display: flex;\n    align-items: center;\n\n    & > span {\n      margin-left: 16px;\n      font-size: 15px;\n      font-weight: 700;\n      color: ",
        ";\n    }\n  }\n\n  & > nav {\n    display: none;\n  }\n\n  &:hover {\n    &::before {\n      background-color: rgba(255, 255, 255, 0.2);\n    }\n\n    & > nav {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  & span {\n    font-size: 15px;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  overflow: hidden;\n\n  & span {\n    overflow: hidden;\n    display: -webkit-box;\n    position: relative;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    ",
        ";\n    text-align: left;\n\n    &::after {\n      display: block;\n      content: '';\n      position: absolute;\n      width: 50px;\n      height: calc(14px * 1.42);\n      top: auto;\n      right: 0;\n      bottom: 0;\n      border-radius: 0;\n      background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 75%);\n    }\n\n    @supports (-webkit-line-clamp: 2) {\n      &::after {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  padding: 8px 24px;\n\n  p {\n    margin-bottom: 16px;\n    color: ",
        ";\n    ",
        ";\n  }\n\n  a {\n    padding: 8px 0;\n    color: ",
        ";\n    ",
        ";\n    background-color: ",
        ";\n    text-align: center;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = SideBar_taggedTemplateLiteral([
        "\n          &::before {\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = SideBar_taggedTemplateLiteral([
        "\n        &::before {\n          background-color: rgba(0, 0, 0, 0.04);\n        }\n      "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  height: 52px;\n  flex-grow: 0;\n  flex-shrink: 1;\n  padding: 8px 24px;\n  background-color: transparent;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 4px;\n    background-color: rgba(0, 0, 0, 0);\n    transition: 0.1s ease;\n  }\n\n  & span {\n    position: relative;\n\n    &::after {\n      display: ",
        ";\n      content: '';\n      position: absolute;\n      top: 0px;\n      right: -6px;\n      width: 4px;\n      height: 4px;\n      border-radius: 100%;\n      background-color: ",
        ";\n    }\n  }\n\n  ",
        " {\n    &:hover {\n      ",
        ";\n    }\n  }\n\n  &:active {\n    ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  justify-content: flex-start;\n  flex: 0 auto;\n  width: 100%;\n  padding: 8px 24px;\n\n  & > svg {\n    margin-right: 16px;\n  }\n\n  & > span {\n    ",
        ";\n\n    ",
        " {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  position: relative;\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  margin-right: 16px;\n  border-radius: 4px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  font-size: 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  justify-content: flex-start;\n  flex: 0 auto;\n  width: 100%;\n  padding: 8px 24px;\n  background-color: transparent;\n\n  & > svg {\n    margin-right: 16px;\n  }\n\n  & > span {\n    ",
        ";\n\n    ",
        " {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  height: 1px;\n  margin: 12px 8px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = SideBar_taggedTemplateLiteral([
        "\n  flex-grow: 0;\n  flex-shrink: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 40px;\n  padding: 8px 24px;\n  margin: 8px 0;\n  background-color: transparent;\n\n  & > span {\n    font-size: 14px;\n    font-weight: 700;\n    color: ",
        ";\n  }\n\n  & > svg {\n    transition: transform 0.2s ease;\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
/**
 * 사이드바
 */ var SideBar = function() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,useStore/* useDispatch */.I)();
    var categoryList = (0,useStore/* useSelector */.v)(function(state) {
        return state.category.categoryList;
    });
    var classList = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.classList.registered;
    });
    var eventList = (0,useStore/* useSelector */.v)(function(state) {
        return state.event.eventList;
    });
    var userInfo = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.info;
    });
    var isYGUser = (ref = userInfo.email) === null || ref === void 0 ? void 0 : ref.includes('@ygmail.net');
    var ref2 = (0,react.useState)(false), isIpadApp = ref2[0], setIsIpadApp = ref2[1];
    var ref3 = (0,react.useState)(false), isExistUser = ref3[0], setIsExistUser = ref3[1];
    var ref4 = (0,react.useState)(false), isFold = ref4[0], setIsFold = ref4[1];
    var foldTarget = (0,react.useRef)(null);
    var categoryNameList = categoryList.map(function(param) {
        var category = param.category;
        return category;
    });
    var onLogin = function() {
        var loginRedirectUrl = (0,helper/* isExistWindow */.br)() ? window.location.pathname : '';
        router.push("/user?url=".concat(loginRedirectUrl));
    };
    var onToggleRegisteredClassList = function() {
        if (!isExistUser) {
            onLogin();
            return;
        }
        setIsFold(function(v) {
            return !v;
        });
    };
    // 고객센터 연결 - 카톡 플러스 친구 챗
    var onCustomerCenter = function() {
        window.location.href = "".concat("https://www.classu.co.kr", "/class/chat/138067");
    };
    // ipadApp check
    (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        setIsIpadApp(device.iPadApp());
    }, []);
    (0,react.useEffect)(function() {
        var target = foldTarget.current;
        if (!target) {
            return;
        }
        if (isFold) {
            target.style.maxHeight = '0px';
        } else {
            target.style.maxHeight = '';
        }
    }, [
        isFold,
        foldTarget
    ]);
    /** 기획전 리스트 호출 */ (0,react.useEffect)(function() {
        if (!router.isReady) {
            return;
        }
        dispatch((0,event_thunk/* getEventList */.Xy)());
    }, [
        dispatch,
        router.isReady
    ]);
    /** 카테고리 호출 */ (0,react.useEffect)(function() {
        if (!router.isReady) {
            return;
        }
        if (isIpadApp) {
            return;
        }
        if (categoryList.length) {
            return;
        }
        dispatch((0,category_thunk/* getCategoryList */.AT)());
    }, [
        dispatch,
        categoryList,
        router.isReady,
        isIpadApp
    ]);
    (0,react.useEffect)(function() {
        return setIsExistUser(userInfo.isLoaded && userInfo.id);
    }, [
        userInfo
    ]);
    var EventButtonList = eventList.map(function(event) {
        var url = event.address.replace(/https:\/\/www.classu.co.kr/gi, "https://www.classu.co.kr");
        if (isIpadApp == false) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: url,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                            src: event.icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: event.title
                        })
                    ]
                })
            }, event.title));
        }
        var ignore = event.address.indexOf('/event') > -1 || event.address.indexOf('/bookmark') > -1 || event.address.indexOf('/awards') > -1 || event.address.indexOf('/external') > -1;
        if (ignore) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, event.title));
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: event.address.replace(/https:\/\/www.classu.co.kr/gi, "https://www.classu.co.kr"),
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                        src: event.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: event.title
                    })
                ]
            })
        }, event.title));
    });
    var ClassList = classList.map(function(cl) {
        var host = "https://www.classu.co.kr";
        var hrefLink = cl.community.open === 'Y' ? "".concat(host, "/community/").concat(cl.community.id) : cl.class_study_status === 'Y' ? "".concat(host, "/class/lecture/").concat(cl.class_id) : "".concat(host, "/class/wait/").concat(cl.class_id);
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: hrefLink,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkItem, {
                color: styles/* palette.grey080 */.DG.grey080,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                        src: cl.photo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cl.class_name
                    })
                ]
            })
        }, cl.class_id));
    });
    var onClickContentLayout = function(e) {
        dispatch((0,dataMining/* setClickedItems */.KB)({
            innerText: e.target.textContent,
            elementType: 'link'
        }));
    };
    var isEnrollCompulsory = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.compulsory.enrolled;
    });
    var userCompany = (ref1 = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.company;
    })) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    (0,react.useEffect)(function() {
        if (router.pathname.split('/').includes('signin')) {
            return;
        }
        if (userInfo && userInfo.id) {
            dispatch((0,user_thunk/* getCompulsory */.Cj)({
                userId: userInfo.id
            }, {
                dispatch: dispatch
            }));
            dispatch((0,user_thunk/* getUserCompany */.pk)({
                userId: userInfo.id
            }, {
                dispatch: dispatch
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.pathname,
        userInfo,
        userInfo.id
    ]);
    var ref5 = (0,react.useState)(false), hasCompanyPublicLectures = ref5[0], setHasCompanyPublicLectures = ref5[1];
    (0,react.useEffect)(function() {
        if (!userCompany) {
            return;
        }
        if (!userCompany.length) {
            return;
        }
        var company = userCompany;
        api/* default.get */.Z.get("/enfit1/api/v3/biz/deal/list?company=".concat(company)).then(function(param) {
            var deal_id_list = param.deal_id_list;
            if (deal_id_list) {
                setHasCompanyPublicLectures(true);
            }
        });
    }, [
        userCompany
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SideBar_Layout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentLayout, {
                onClick: onClickContentLayout,
                children: [
                    !isIpadApp && router.isReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideTop, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryButton, {
                            size: "Small",
                            color: styles/* palette.Primary.Active */.DG.Primary.Active,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                            name: "ic_category",
                                            width: 24,
                                            height: 24,
                                            fill: styles/* palette.white */.DG.white
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "카테고리"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                    name: "ic_arrow_right_r",
                                    width: 16,
                                    height: 16,
                                    fill: styles/* palette.white */.DG.white
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_SideNavigation, {
                                    categoryList: categoryNameList
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideBottom, {
                        isIpadApp: isIpadApp,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListBox, {
                                children: !!eventList.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        EventButtonList,
                                        hasCompanyPublicLectures && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/event/".concat(userCompany).replace(/https:\/\/www.classu.co.kr/gi, "https://www.classu.co.kr"),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                                                        src: "https://file.classu.co.kr/biz/".concat(userCompany, "-logo.png")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: (0,companyConvert/* companyConvert_Sidebar */.w)(userCompany)
                                                    })
                                                ]
                                            })
                                        }),
                                        isEnrollCompulsory && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: '/event/plan/compulsory'.replace(/https:\/\/www.classu.co.kr/gi, "https://www.classu.co.kr"),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                                                        src: "https://file.classu.co.kr/biz/icon.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "법정의무교육"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/community",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                                        name: "dark_community",
                                                        width: 20,
                                                        height: 14,
                                                        fill: styles/* palette.white */.DG.white
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            marginLeft: '20px'
                                                        },
                                                        children: "커뮤니티"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownButton, {
                                        size: "Small",
                                        color: styles/* palette.grey080 */.DG.grey080,
                                        isFold: isFold,
                                        onClick: onToggleRegisteredClassList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "수강 중인 클래스"
                                            }),
                                            !!userInfo.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                                name: "ic_arrow_down_m",
                                                width: 16,
                                                height: 16,
                                                fill: styles/* palette.grey060 */.DG.grey060
                                            })
                                        ]
                                    }),
                                    userInfo.id && !!classList.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassListBox, {
                                        ref: foldTarget,
                                        children: ClassList
                                    }),
                                    userInfo.id && !classList.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyClassListBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "수강 중인 클래스가 없어요"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/search?keyword=",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fill/* default */.Z, {
                                                    as: "a",
                                                    children: "클래스 탐색하기"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/biz",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconLink, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                            name: "biz-icon",
                                            width: 20,
                                            height: 20,
                                            fill: styles/* palette.white */.DG.white
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "기업교육"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton, {
                                color: styles/* palette.grey080 */.DG.grey080,
                                onClick: onCustomerCenter,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        name: "ic_customer_center",
                                        width: 20,
                                        height: 20,
                                        stroke: styles/* palette.grey50 */.DG.grey50
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "고객센터"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var SideBar_Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-351b90f6-0"
})(SideBar_templateObject(), styles/* zIndex.header */.W5.header, styles/* mediaQuery.large */.cy.large, styles/* palette.grey50 */.DG.grey50);
var Inner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-351b90f6-1"
})(SideBar_templateObject1(), styles/* palette.system.BNB */.DG.system.BNB);
var ContentLayout = (0,styled_components_browser_esm/* default */.ZP)(VerticalScroll/* default */.Z).withConfig({
    componentId: "sc-351b90f6-2"
})(_templateObject2());
var SideTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-351b90f6-3"
})(_templateObject3());
var CategoryButton = (0,styled_components_browser_esm/* default */.ZP)(Fill/* default */.Z).withConfig({
    componentId: "sc-351b90f6-4"
})(_templateObject4(), styles/* palette.white */.DG.white);
var SideBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-351b90f6-5"
})(_templateObject5(), function(param) {
    var isIpadApp = param.isIpadApp;
    return isIpadApp ? "padding: 8px;" : "padding: 60px 8px 8px;";
});
var EventListBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-351b90f6-6"
})(_templateObject6(), styles/* palette.grey080 */.DG.grey080);
var ClassListBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-351b90f6-7"
})(_templateObject7(), typography/* body3_regular */.PD);
var EmptyClassListBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-351b90f6-8"
})(_templateObject8(), styles/* palette.grey040 */.DG.grey040, typography/* caption2_regular */.Ug, styles/* palette.grey060 */.DG.grey060, typography/* caption2_medium */.pn, styles/* palette.grey010 */.DG.grey010);
var LinkItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-351b90f6-9"
})(_templateObject11(), function(param) {
    var selected = param.selected;
    return selected ? 'block' : 'none';
}, styles/* palette.red040 */.DG.red040, styles/* onlyHover */.kC, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
}, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject10());
});
var IconLink = (0,styled_components_browser_esm/* default */.ZP)(LinkItem).withConfig({
    componentId: "sc-351b90f6-10"
})(_templateObject12(), typography/* body3_regular */.PD, styles/* mediaQuery.large */.cy.large);
var Cover = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(param) {
    var src = param.src;
    return {
        style: {
            backgroundImage: "url(".concat(src, ")")
        }
    };
}).withConfig({
    componentId: "sc-351b90f6-11"
})(_templateObject13());
var IconButton = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-351b90f6-12"
})(_templateObject14(), typography/* body3_regular */.PD, styles/* mediaQuery.large */.cy.large);
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-351b90f6-13"
})(_templateObject15(), styles/* palette.system.grey */.DG.system.grey);
var DropDownButton = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-351b90f6-14"
})(_templateObject16(), styles/* palette.grey50 */.DG.grey50, function(param) {
    var isFold = param.isFold;
    return isFold ? 'rotate(0deg)' : 'rotate(180deg)';
});
/* harmony default export */ var common_SideBar = (SideBar);


/***/ }),

/***/ 4335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7379);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var components_organisms_common_NotificationCenter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2747);
/* harmony import */ var components_molecules_headers_SearchInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3349);
/* harmony import */ var components_atoms_photos_Avatar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3315);
/* harmony import */ var components_atoms_icons_Notify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7068);
/* harmony import */ var cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7732);
/* harmony import */ var cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5549);
/* harmony import */ var cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5472);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6643);
/* harmony import */ var components_layout_headers_Base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6332);
/* harmony import */ var hooks_common_useStore__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8004);
/* harmony import */ var hooks_bridge_useBridgeCallback__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8372);
/* harmony import */ var lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7496);
/* harmony import */ var lib_utils_helper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4058);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3887);





// components









// hooks


// utils


// styles

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 240px calc(100vw - 240px);\n\n  height: 100%;\n  margin: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 32px;\n  height: 56px;\n  margin-left: 12px;\n\n  ",
        " {\n    height: 32px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  width: 50px;\n\n  &:first-child {\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  &:last-child {\n    display: flex;\n    justify-content: flex-end;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: none;\n  position: relative;\n\n  ",
        " {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  & > button,\n  & > a:not(:first-child) {\n    margin-left: 8px;\n  }\n\n  ",
        " {\n    & > button,\n    & > a:not(:first-child) {\n      margin-left: 12px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n          &::before {\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n        &::before {\n          background-color: rgba(0, 0, 0, 0.04);\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 12px;\n  margin-right: 4px;\n  font-weight: 500;\n  font-size: 14px;\n  color: ",
        ";\n  background-color: ",
        ";\n  min-width: 90px;\n\n  ",
        " {\n    &:hover {\n      ",
        ";\n    }\n  }\n\n  &:active {\n    ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    &:hover {\n      &:hover {\n        border-radius: 4px;\n        background-color: rgba(0, 0, 0, 0.04);\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 12px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n\n  & > div {\n    border: 1px solid white;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n  flex-grow: 0;\n  padding: 6px 12px;\n  font-size: 12px;\n  color: ",
        ";\n  background-color: ",
        ";\n  border: none;\n  cursor: pointer;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 36px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 48px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 240px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 240px);\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 2px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
/** 메인 헤더 */ var MainPcHeader = function(_param) {
    var onOpenNotify = function onOpenNotify() {
        if (!isExistUser) {
            onLogin();
            return;
        }
        var notifyEvent = new CustomEvent('onOpenNotify', {
            detail: {
                winWidth: window.outerWidth
            }
        });
        document.dispatchEvent(notifyEvent);
    };
    var props = _extends({}, _param);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = _slicedToArray((0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_13__/* .useSelector */ .v)(function(state) {
        return [
            state.user.info,
            state.user.newsCount.chat_unread_count,
            state.user.newsCount.news_unread_count, 
        ];
    }), 3), userInfo = ref[0], existChat = ref[1], existNotification = ref[2];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isIpadApp = ref1[0], setIsIpadApp = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isEnableNotify = ref2[0], setIsEnableNotify = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isVisibleNotify = ref3[0], setIsVisibleNotify = ref3[1];
    var isOpenMenu = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(true);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), naviIsHide = ref4[0], setNaviIsHide = ref4[1];
    var isExistUser = userInfo.isLoaded && userInfo.id;
    (0,hooks_bridge_useBridgeCallback__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        onOpenNotify: onOpenNotify
    });
    var onToggleMenu = function() {
        setNaviIsHide(function(prev) {
            return !prev;
        });
        var menu = document.querySelector('#left-side');
        var content = document.querySelector('#right-side');
        if (!menu || !content) {
            return;
        }
        if (isOpenMenu.current) {
            isOpenMenu.current = false;
            menu.style.display = 'none';
            content.style.maxWidth = '100%';
        } else {
            isOpenMenu.current = true;
            menu.removeAttribute('style');
            content.removeAttribute('style');
        }
    };
    var onLogin = function() {
        var loginRedirectUrl = (0,lib_utils_helper__WEBPACK_IMPORTED_MODULE_16__/* .isExistWindow */ .br)() ? window.location.pathname : '';
        router.push("/user?url=".concat(loginRedirectUrl));
    };
    var onMouseDown = function(e) {
        if (e.buttons === 4) {
            var loginRedirectUrl = (0,lib_utils_helper__WEBPACK_IMPORTED_MODULE_16__/* .isExistWindow */ .br)() ? window.location.pathname : '';
            router.push("/user?url=".concat(loginRedirectUrl));
        }
    };
    var onChat = function() {
        if (!isExistUser) {
            onLogin();
            return;
        }
        window.location.href = "".concat("https://www.classu.co.kr", "/class/chat");
    };
    var onToggleNotify = function() {
        if (!isExistUser) {
            onLogin();
            return;
        }
        setIsVisibleNotify(function(v) {
            return !v;
        });
    };
    var doOpenNotify = function(param) {
        var detail = param.detail;
        var winWidth = detail.winWidth;
        if (winWidth < cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.large */ .cy.large) {
            return;
        }
        setIsVisibleNotify(true);
    };
    // ipadApp check
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)();
        setIsIpadApp(device.iPadApp());
    }, []);
    /** 알림 아이콘 표시 여부 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)();
        if (device.app()) {
            setIsEnableNotify(false);
        } else {
            setIsEnableNotify(true);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isEnableNotify) {
            return;
        }
        document.addEventListener('onOpenNotify', doOpenNotify);
        return function() {
            document.removeEventListener('onOpenNotify', doOpenNotify);
        };
    }, [
        isEnableNotify
    ]);
    var LeftSide = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LeftSideLayout, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuButton, {
                onClick: onToggleMenu,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    name: "ic_category",
                    fill: cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.grey75 */ .DG.grey75
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(IconWrapper, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            name: "logo_white",
                            width: 110,
                            height: 20
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            name: "logo_symbol",
                            width: 12,
                            height: 13
                        })
                    ]
                })
            })
        ]
    });
    var RightSide = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RightSideLayout, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "".concat("https://www.classu.co.kr", "/class/open"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClassOpenButton, {
                    size: "32px",
                    color: cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.grey020 */ .DG.grey020,
                    children: "클래스개설"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "".concat("https://www.classu.co.kr", "/class/chat"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemButton, {
                    width: 32,
                    height: 32,
                    onClick: onChat,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_icons_Notify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        name: "ic_chat",
                        fill: cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.BTN.Color0 */ .DG.BTN.Color0,
                        width: 24,
                        height: 24,
                        isActive: !!existChat
                    })
                })
            }),
            isEnableNotify && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemButton, {
                width: 32,
                height: 32,
                onClick: onToggleNotify,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_icons_Notify__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    width: 24,
                    height: 24,
                    isActive: !!existNotification,
                    fill: cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.BTN.Color0 */ .DG.BTN.Color0
                })
            }),
            isExistUser && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                href: "/user/".concat(userInfo.id),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarButton, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_photos_Avatar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            width: 32,
                            height: 32,
                            src: userInfo.photo,
                            alt: userInfo.name
                        })
                    })
                })
            }),
            !isExistUser && userInfo.isLoaded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoginButton, {
                size: "32px",
                color: cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.grey050 */ .DG.grey050,
                onClick: onLogin,
                onMouseDown: onMouseDown,
                children: "로그인"
            }),
            !userInfo.isLoaded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoginSkeleton, {})
        ]
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_headers_Base__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, _objectSpread({}, props, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentLayout, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftSideContainer, {
                            naviIsHide: naviIsHide,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                                children: LeftSide
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RightSideContainer, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchInputWrapper, {
                                    children: !isIpadApp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_headers_SearchInput__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightItem, {
                                    children: RightSide
                                })
                            ]
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_headers_Base__WEBPACK_IMPORTED_MODULE_12__/* .HeaderBlank */ .m, {}),
            isExistUser && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_organisms_common_NotificationCenter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                isVisible: isVisibleNotify,
                onClose: onToggleNotify
            })
        ]
    }));
};
var ContentLayout = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-0"
})(_templateObject());
var LoginSkeleton = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.large */ .cy.large);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-2"
})(_templateObject2());
var LeftSideLayout = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-3"
})(_templateObject3());
var RightSideLayout = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-4"
})(_templateObject4(), cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.large */ .cy.large);
var ClassOpenButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71f8699a-5"
})(_templateObject7(), cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.BTN.BG */ .DG.BTN.BG, cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .onlyHover */ .kC, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(_templateObject5());
}, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(_templateObject6());
});
var ItemButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71f8699a-6"
})(_templateObject8(), cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .onlyHover */ .kC);
var MenuButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(ItemButton).withConfig({
    componentId: "sc-71f8699a-7"
})(_templateObject9());
var AvatarButton = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-8"
})(_templateObject10());
var LoginButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71f8699a-9"
})(_templateObject11(), cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.BTN.BG */ .DG.BTN.BG);
var LeftSideContainer = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-10"
})(_templateObject12(), function(param) {
    var naviIsHide = param.naviIsHide;
    return naviIsHide ? cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.system.BG */ .DG.system.BG : cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.system.BNB */ .DG.system.BNB;
});
var RightSideContainer = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-11"
})(_templateObject13(), cds_styles__WEBPACK_IMPORTED_MODULE_15__/* .palette.system.BG */ .DG.system.BG);
var RightItem = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-12"
})(_templateObject14());
var SearchInputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-13"
})(_templateObject15());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71f8699a-14"
})(_templateObject16());
/* harmony default export */ __webpack_exports__["Z"] = (MainPcHeader);


/***/ }),

/***/ 5836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ companyConvert; },
/* harmony export */   "w": function() { return /* binding */ companyConvert_Sidebar; }
/* harmony export */ });
/** @param {string} company */ var companyConvert = function(company) {
    if (company === 'yg') {
        return 'YG 임직원 전용관';
    }
    if (company === 'jw') {
        return 'JW Adv';
    }
    if (company) {
        var companyUpper = company.toUpperCase();
        return "".concat(companyUpper, " 임직원 전용관");
    }
    return '임직원 전용관';
};
/** @param {string} company */ var companyConvert_Sidebar = function(company) {
    if (company === 'yg') {
        return 'YG 임직원 전용관';
    }
    if (company === 'jw') {
        return 'JW Adv';
    }
    return '임직원 전용관';
};


/***/ }),

/***/ 7026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xy": function() { return /* binding */ getEventList; },
/* harmony export */   "EY": function() { return /* binding */ getEvent; },
/* harmony export */   "Ty": function() { return /* binding */ getEventBanner; }
/* harmony export */ });
/* unused harmony export getMonthEvent */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5700);
/* harmony import */ var slices_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1283);
/* harmony import */ var api_event__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8797);
/* harmony import */ var lib_utils_format_time__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(508);


// actions

// api

// utils

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getDateDiff = function(start, end) {
    return ((start.getTime() - end.getTime()) / (1000 * 60 * 60 * 24)).toFixed(0) * 1;
};
/** 초저가 이벤트 호출 */ var getMonthEvent = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)('event/getMonthEvent', function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_, param) {
        var dispatch, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    dispatch = param.dispatch;
                    _ctx.next = 3;
                    return api_event__WEBPACK_IMPORTED_MODULE_2__/* .getMonthEvent */ .Yu();
                case 3:
                    res = _ctx.sent;
                    dispatch(slices_event__WEBPACK_IMPORTED_MODULE_1__/* .updateMonth */ .aM({
                        classList: res.list
                    }));
                    return _ctx.abrupt("return", Promise.resolve(true));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
/** 이벤트 정보 리스트 호출 */ var getEventList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)('event/getEventList', function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_, param) {
        var dispatch, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    dispatch = param.dispatch;
                    _ctx.next = 3;
                    return api_event__WEBPACK_IMPORTED_MODULE_2__/* .getEventList */ .Xy();
                case 3:
                    res = _ctx.sent;
                    dispatch(slices_event__WEBPACK_IMPORTED_MODULE_1__/* .updateEventList */ .a5(res));
                    return _ctx.abrupt("return", Promise.resolve(true));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_, _2) {
        return _ref.apply(this, arguments);
    };
}());
/**
 * 이벤트 정보 호출
 * @param {object} data
 * @param {string} data.planId
 */ var getEvent = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)('event/getEvent', function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
        var planId, dispatch, res, today, onlyOpenClassListForEvent, updateRes;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    planId = param.planId, dispatch = param1.dispatch;
                    _ctx.next = 3;
                    return api_event__WEBPACK_IMPORTED_MODULE_2__/* .getEvent */ .EY({
                        dealId: planId
                    });
                case 3:
                    res = _ctx.sent;
                    if (parseInt(planId) === 1) {
                        today = (0,lib_utils_format_time__WEBPACK_IMPORTED_MODULE_4__/* .getKoreaDate */ .jw)();
                        onlyOpenClassListForEvent = res.list.filter(function(v) {
                            return (getDateDiff((0,lib_utils_format_time__WEBPACK_IMPORTED_MODULE_4__/* .dateTimeFormatter */ .CI)(v.close_date), today) === 0 || getDateDiff((0,lib_utils_format_time__WEBPACK_IMPORTED_MODULE_4__/* .dateTimeFormatter */ .CI)(v.close_date), today) <= 7) && v;
                        });
                        updateRes = Object.assign(res, {
                            list: onlyOpenClassListForEvent
                        });
                        dispatch(slices_event__WEBPACK_IMPORTED_MODULE_1__/* .setPlan */ .cu(updateRes));
                    } else {
                        dispatch(slices_event__WEBPACK_IMPORTED_MODULE_1__/* .setPlan */ .cu(res));
                    }
                    return _ctx.abrupt("return", Promise.resolve(true));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_, _3) {
        return _ref.apply(this, arguments);
    };
}());
/** 이벤트 배너 정보 호출 */ var getEventBanner = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)('event/getEventBanner', function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_, param) {
        var dispatch, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    dispatch = param.dispatch;
                    _ctx.next = 3;
                    return api_event__WEBPACK_IMPORTED_MODULE_2__/* .getEventBanner */ .Ty();
                case 3:
                    res = _ctx.sent;
                    dispatch(slices_event__WEBPACK_IMPORTED_MODULE_1__/* .updateEventBanner */ .oT(res.event_list));
                    return _ctx.abrupt("return", Promise.resolve(true));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_, _4) {
        return _ref.apply(this, arguments);
    };
}());


/***/ })

}]);